import { ApplicationToComponentStrategyInterface }
  from '~/modules/Products/Infrastructure/ApplicationToComponentStrategies/ApplicationToComponentStrategyInterface'
import { ApplicationProductDto } from '~/modules/Products/Application/ApplicationProductDto'
import { ComponentProductDto } from '~/modules/Products/Infrastructure/Dtos/ComponentProductDto'
import { ApplicationToComponentStrategyResolverException } from './ApplicationToComponentStrategyResolverException'

export class ApplicationToComponentStrategyResolver {
  // eslint-disable-next-line no-useless-constructor
  constructor (
    private readonly strategies: ApplicationToComponentStrategyInterface[]
  ) {}

  public resolve (applicationProductDto: ApplicationProductDto): ComponentProductDto {
    for (const strategy of this.strategies) {
      if (strategy.doesFit(applicationProductDto)) {
        return strategy.toComponentDto(applicationProductDto)
      }
    }

    throw ApplicationToComponentStrategyResolverException.fittingStrategyNotFound()
  }
}
